import { createFileRoute } from "@tanstack/react-router";
import { CoachesPage } from "@/components/coaches/CoachesPage";
import { listCoachPosts } from "@/lib/blog.functions";
import careersCss from "@/careers/careers.css?url";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
import { COACHES_ALTERNATES } from "@/components/coaches/coaches-alternates";

const CHROME_LINKS = [
  { rel: "stylesheet", href: careersCss },
];

// /az/coaches — AZ locale. Dedicated route per the privacy convention
// (no query-param routing; query strings are unreliable in TanStack
// Start server handlers).

export const Route = createFileRoute("/az/coaches")({
  // Статьи коучей в блоге на языке страницы; сбой чтения — страница без них.
  loader: async () => ({ posts: await listCoachPosts({ data: { lang: "az" } }).catch(() => ({})) }),
  head: () => ({
    meta: [
      { title: "Yolutap kouçları — fərdi karyera məsləhətləri" },
      {
        name: "description",
        content:
          "Yolutap-ın sertifikatlı kouçları — diaqnostikadan sonra fərdi karyera məsləhətləri. Yeniyetməyə nəticələri gələcəyə doğru şüurlu addımlara çevirməkdə kömək.",
      },
      { property: "og:title", content: "Yolutap kouçları — fərdi karyera məsləhətləri" },
      {
        property: "og:description",
        content:
          "Yeniyetməyə diaqnostika nəticələrini gələcəyə doğru şüurlu addımlara çevirməyə kömək edən sertifikatlı mütəxəssislər.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://yolutap.com/az/coaches" },
      { property: "og:image", content: "https://yolutap.com/photos/teen_boy_hero.jpg" },
      { property: "og:locale", content: "az_AZ" },
      { name: "twitter:title", content: "Yolutap kouçları — fərdi karyera məsləhətləri" },
      { name: "twitter:description", content: "Yeniyetməyə diaqnostika nəticələrini gələcəyə doğru şüurlu addımlara çevirməyə kömək edən sertifikatlı mütəxəssislər." },
    ],
    links: [{ rel: "canonical", href: "https://yolutap.com/az/coaches" }, ...COACHES_ALTERNATES, ...CHROME_LINKS, ...SITE_CHROME_LINKS],
  }),
  component: function Page() {
    const { posts } = Route.useLoaderData();
    return <CoachesPage lang="az" posts={posts} />;
  },
});
